module.exports = __webpack_public_path__ + "img/s3CardIcon3.bf716969.png";